import { useState, useCallback } from 'react';
import { getESMStocks } from '@/lib/api/esmStocksApi';
import { ESMStockListItemFE } from '@/types/esmStock';

export function useESMStocks() {
  const [stocks, setStocks] = useState<ESMStockListItemFE[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchESMStocks = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getESMStocks(filters);
      setStocks(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load ESM stock data. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    stocks,
    loading,
    error,
    fetchESMStocks,
  };
} 